import React, { useState } from 'react';
import './LogInComponent.css';
import { GetToken } from '../Backend/ApiCalls';
import { Notification } from './NotificationLoginComponent';
import { setPrimaryProfileToken } from '../utils/profileStorage';
import eyeIcon from "../Assets/Images/ojoNC.png";  // Ícono del ojo abierto
import eyeSlashIcon from "../Assets/Images/cerrar-ojoNC.png"; // Ícono del ojo cerrado

export const LogInComponent = (props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [showNotification, setShowNotification] = useState(false);
    const [isErrorNoti, setErrorNoti] = useState(false);
    const [showPassword, setShowPassword] = useState(false);  // Estado para alternar la visibilidad de la contraseña

    // Alternar visibilidad de la contraseña
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const userId = document.getElementById('userId').value;
        const password = document.getElementById('password').value;

        const { response, json } = await GetToken(userId, password);
        if (!response.ok) {
            setErrorMessage(props.I18n.ErrorMessageLogin);
            setErrorNoti(true);
        } else {
            setErrorMessage(props.I18n.SuccessMessageLogin);
            setErrorNoti(false);
            setPrimaryProfileToken(json.loginToken);
            setTimeout(() => {
                window.location.href = '/perfil';
            }, 3000);
        }
        setShowNotification(true);

        setTimeout(() => {
            setShowNotification(false);
        }, 5000);
    };

    return (
        <>
            <div className='login-content'>
                {showNotification && <Notification message={errorMessage} type={isErrorNoti ? "error" : "success"} />}
                <div id="iniciar-sesion">
                    <h1>{props.I18n.LogIn}</h1>

                    <form name="LoginForm" onSubmit={handleSubmit}>
                        <div className="form__group field">
                            <input type="text" className="form__field login-input" placeholder="ID Fallero" name="userId" id="userId" required />
                            <label htmlFor="name" className="form__label">{props.I18n.IDFallero}</label>
                        </div>

                        <div className="form__group field password-container">
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="form__field login-input" 
                                placeholder="Contraseña" 
                                name="password" 
                                id="password" 
                                required 
                            />
                            <img
                                src={showPassword ? eyeIcon : eyeSlashIcon}
                                alt="Toggle Password Visibility"
                                className="password-icon"
                                onClick={togglePasswordVisibility}
                            />
                            <label htmlFor="password" className="form__label">{props.I18n.Password}</label>
                        </div>

                        <p className="nota-informativa">
                            <strong>{props.I18n.Note}:</strong> {props.I18n.NoteInstructions}
                            <br />
                            <em>{props.I18n.Example}:</em> {props.I18n.ExamplePassword}
                        </p>

                        <button id="log" className="log" type="submit">{props.I18n.GetIn}</button>
                    </form>
                </div>
            </div>
        </>
    );
};
